import { render, staticRenderFns } from "./notificationDetail.vue?vue&type=template&id=8eecdb3a"
import script from "./notificationDetail.vue?vue&type=script&lang=js"
export * from "./notificationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports